import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initState = {
    locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en-US'
}

const localeSlice = createSlice({
    name: 'locale',
    initialState: initState,
    reducers: {
      // standard reducer logic, with auto-generated action types per reducer
        changeLocale: (state, action) => {
            state.locale = action.payload
            localStorage.setItem('lang', action.payload)
        }
    },
})

export const { changeLocale } = localeSlice.actions

export default localeSlice.reducer